/*********************************
 * import and create pimia state *
 *********************************/
import { createPinia } from "pinia";

const pinia = createPinia();
export default pinia;
/*********************************/


/************************************
 * import the dashboard state links *
 ************************************/
//default dashboard state
import { useLayoutStore } from "./pinia/layout";
// import { useAuthFakeStore } from "./pinia/authFake";
// import { useNotificationStore } from "./pinia/notification";
// import { useTodoStore } from "./pinia/todo";

//custom  dashboard state
import { useAdminStore } from "./modules/admin";
import { useAuthStore } from "./modules/auth";
import { useLogStore } from "./modules/log";
// import { useStstisticStore } from "./modules/ststistic";
import { useDeathCertificateStore } from './modules/deathCertificate';
// import { useDistrictStore } from './modules/district';
// import { useGovernorateStore } from './modules/governorate';
import { useMartyrSacrificeStore } from './modules/martyrSacrifice';
import { usePoliceStore } from './modules/police';
// import { useRegionStore } from './modules/region';
import { useResidenceDataStore } from './modules/residenceData';
import { useSacrificerStore } from './modules/sacrificer';
// import { useTownshipStore } from './modules/township';
import { useMartyrsStore } from './modules/martyrs';
import { useWoundedStore } from './modules/woundeds';
import { useDeceasedStore } from "./modules/Deceaseds"; 
import { useBeneficiaryStore } from "./modules/beneficiaries";
import { useJobRecordStore } from "./modules/jobRecord";
import { useAdminsStore } from "./modules/admin";
import { useSkillsPersonStore } from "./modules/skillPerson";

//Sutting
import { useGovernorateStore } from "./modules/sutting/governorate";
import { useAdmissionChannelsStore } from "./modules/sutting/admissionChannels";
import { useAlmelakatStore } from "./modules/sutting/almelakats";
import { useBodyMainPartsStore } from "./modules/sutting/_bodyMainParts";
import { useBodySideStore } from "./modules/sutting/bodySide";
import { useBodySubPartsStore } from "./modules/sutting/bodySubParts";
import { useCollegesStore } from "./modules/sutting/colleges";
import { useDepartmentsStore } from "./modules/sutting/departments";
import { useDistrictsStore } from "./modules/sutting/districts";
import { useEducationalInstitutionsStore } from "./modules/sutting/educationalInstitutions";
import { useFileNamesStore } from "./modules/sutting/fileNames";
import { useHousingTypeStore } from "./modules/sutting/housingType";
import { useInstitutionsStore } from "./modules/sutting/institutions";
import { useIssuersNewIdentificationCardsStore } from "./modules/sutting/issuersNewIdentificationCards";
import { useIssuersOldIdentificationCardsStore } from "./modules/sutting/issuersOldIdentificationCards";
import { useIssuersPassportsStore } from "./modules/sutting/issuersPassports";
import { useIssuersResidentialCardsStore } from "./modules/sutting/issuersResidentialCards";
import { useLevelOneStore } from "./modules/sutting/levelOne";
import { useLevelThreeStore } from "./modules/sutting/levelThree";
import { useLevelTwoStore } from "./modules/sutting/levelTwo";
import { useOwnershipTypesStore } from "./modules/sutting/ownershipTypes";
import { usePlaceAffiliationsStore } from "./modules/sutting/placeAffiliations";
import { usePositionsStore } from "./modules/sutting/positions";
import { useRegionsStore } from "./modules/sutting/regions";
import { useSkillsStore } from "./modules/sutting/skills";
import { useTownshipsStore } from "./modules/sutting/townships";
import { useTypeInjuriesStore } from "./modules/sutting/typeInjuries";
import { useMartyrDataStore } from "./modules/martyrData";
import { useEducationCurrentDataStore } from './modules/educationCurrentData';
import { useEducationDataStore } from './modules/educationData';
import { useAdministrativeDataStore } from './modules/administrativeData';
import { usePreviousEmploymentStore } from './modules/previousEmployment';
import { useEmploymentRecordStore } from './modules/employmentRecord';
import { useArchiveStore } from './modules/archive';
import { useCategoriesStore } from './modules/sutting/categories';
import { usePersonTypesStore } from './modules/sutting/personTypes';
import { useSettingsStore } from './modules/sutting/settings';



import { useNewIdentificationCardStore } from './modules/newIdentificationCard';
import { useOldIdentificationCardStore } from './modules/oldIdentificationCard';
import { usePassportStore } from './modules/passport';
import { useRationCardStore } from './modules/rationCard';
import { useResidentialCardStore } from './modules/residentialCard';

import {useContactStore} from './modules/contact';
import {useSocialMediaStore} from './modules/socialMedia';
import {useSacrificeDataStore} from './modules/sacrificeData';
import { useSelfEmploymentStore } from './modules/selfEmployment';

import { useRolesStore } from './modules/sutting/roles';
import { useStatisticStore } from './modules/ststistic';

export { 
    //default dashboard state
    useLayoutStore,
    // useAuthFakeStore,
    // useNotificationStore,
    // useTodoStore

    // import the dashboard state links.
    useAdminStore,
    useAuthStore,
    useLogStore,
    // useStstisticStore,
    useDeathCertificateStore,
    // useDistrictStore,
    // useGovernorateStore,
    useMartyrSacrificeStore,
    usePoliceStore,
    // useRegionStore,
    useResidenceDataStore,
    useSacrificerStore,
    // useTownshipStore,
    useMartyrsStore,
    useWoundedStore,
    useDeceasedStore,
    useBeneficiaryStore,
    useMartyrDataStore,
    useEducationCurrentDataStore,
    useEducationDataStore,
    useAdministrativeDataStore,
    usePreviousEmploymentStore,
    useEmploymentRecordStore,
    useArchiveStore,
    useNewIdentificationCardStore,
    useOldIdentificationCardStore,
    usePassportStore,
    useRationCardStore,
    useResidentialCardStore,
    useContactStore,
    useSocialMediaStore,
    useSacrificeDataStore,
    useSelfEmploymentStore,
    useJobRecordStore,
    useAdminsStore,
    useRolesStore,
    useStatisticStore,
    useSkillsPersonStore,
    
    //Sutting
    useGovernorateStore,
    useDistrictsStore,
    useTownshipsStore,
    useRegionsStore,
    useAdmissionChannelsStore,
    useAlmelakatStore,
    useBodyMainPartsStore,
    useBodySideStore,
    useBodySubPartsStore,
    useCollegesStore,
    useDepartmentsStore,
    useEducationalInstitutionsStore,
    useFileNamesStore,
    useHousingTypeStore,
    useInstitutionsStore,
    useIssuersNewIdentificationCardsStore,
    useIssuersOldIdentificationCardsStore,
    useIssuersPassportsStore,
    useIssuersResidentialCardsStore,
    useLevelOneStore,
    useLevelThreeStore,
    useLevelTwoStore,
    useOwnershipTypesStore,
    usePlaceAffiliationsStore,
    usePositionsStore,
    useSkillsStore,
    useTypeInjuriesStore,
    useCategoriesStore,
    usePersonTypesStore,
    useSettingsStore
 };
